import React, { useState, useEffect } from "react";
import tableIcons from "../../components/tableicon/table-icons";
import MaterialTable from "material-table";
import { firefunctions } from "../../components/firebase/FirebaseProvider";
import AppLoading from "../../components/appLoading";
import {
  AppBar,
  Container,
  Grid,
  Toolbar,
} from "@material-ui/core";
import useStyles from "./style";
import Paper from "@material-ui/core/Paper";
import TokorameIcon from "../../assets/logo-tokorame.svg";
import Footer from "../../components/molecules/LoginNav/footer";

function StokProduk() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [table, setTable] = useState({
    columns: [
      {
        title: "Nomer",
        field: "nomer",
        filtering: false,
        render: (rowData) => (
          <>
            {rowData && rowData.variant_1 !== "" ? (
              rowData.nomer
            ) : (
              <b>{rowData.nomer}</b>
            )}
          </>
        ),
      },
      // {
      //   title: "Product Id",
      //   // lookup: {},
      //   filtering: false,
      //   field: "sku",
      //   render: (rowData) => (
      //     <>
      //       {rowData && rowData.variant_1 !== "" ? (
      //         rowData.sku
      //       ) : (
      //         <b>{rowData.sku}</b>
      //       )}
      //     </>
      //   ),
      // },
      // { title: "variant_id", field: "variant_id" },
      {
        title: "Nama Produk",
        lookup: {},
        // filtering: false,
        field: "nama_produk",
        render: (rowData) => (
          <>
            {rowData && rowData.variant_1 !== "" ? (
              rowData.nama_produk
            ) : (
              <b>{rowData.nama_produk}</b>
            )}
          </>
        ),
      },
      {
        title: "Kategori",
        field: "kategori3",
        lookup: {},
        render: (rowData) => (
          <>
            {rowData && rowData.variant_1 !== "" ? (
              rowData.kategori3
            ) : (
              <b>{rowData.kategori3}</b>
            )}
          </>
        ),
      },
      { title: "Variant", filtering: false, field: "variant_1" },
      { title: "Variant", filtering: false, field: "variant_2" },
      {
        title: "Stok",
        filtering: false,
        field: "stok",
        render: (rowData) => (
          <>
            {rowData && rowData.variant_1 !== "" ? (
              rowData.stok
            ) : (
              <b>{rowData.stok}</b>
            )}
          </>
        ),
      },
    ],
    data: [],
  });
  // console.log({...obj});

  const getData = async () => {
    setLoading(true);

    try {
      const func = firefunctions.httpsCallable("getVariants");

      const res = await func({});
      let angka = 0;
      setTable((table) => {
        const obj = {
          ...table,
          data: res?.data.map((doc) => {
            return {
              ...doc,
              nomer: !doc.variant_1 ? (angka += 1) : "",
              nama_produk: doc.nama_produk,
              product_id: doc.product_id,
              stok: doc.stok || 0,
              variant_1: doc.variant_1,
              variant_2: doc.variant_2,
              variant_id: doc.variant_id,
            };
          }),
        };
        let kateg3 = {};
        res?.data.forEach((item) => {
          if (item.kategori3) {
            kateg3[item.kategori3] = item.kategori3;
          }
        });
        obj.columns[2].lookup = kateg3;

        let prod = {};
        res?.data.forEach((item) => {
          if (item.nama_produk) {
            prod[item.nama_produk] = item.nama_produk;
          }
        });
        obj.columns[1].lookup = prod;

        return obj;
      });

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  if (loading) {
    return <AppLoading />;
  }

  return (
    <Grid container xs={12}>
      <Paper className={classes.paperWrap}>
        <AppBar position="static">
          <Toolbar>
            <div className={classes.wrapHeader}>
              <div className={classes.wrapIcon}>
                <img src={TokorameIcon} alt="tokorame" />
              </div>
            </div>
          </Toolbar>
        </AppBar>
        <div className={classes.pageWrapWrap}>
          <div className={classes.content}>
            <div className={classes.root}>
              <Container>
                <MaterialTable
                  columns={table.columns}
                  data={table.data}
                  title="List Stok Produk"
                  icons={tableIcons}
                  options={{
                    pageSize: 100,
                    pageSizeOptions: [100, 150, 200],
                    sorting: false,
                    headerStyle: {
                      fontWeight: "bold",
                    },
                    filtering: true,
                  }}
                  localization={{
                    body: {
                      emptyDataSourceMessage: "Tidak Ada Data",
                    },
                    toolbar: {
                      searchTooltip: "Cari",
                      searchPlaceholder: "Cari Data",
                    },
                    header: {
                      actions: "Actions",
                    },
                    pagination: {
                      labelRowsSelect: "Baris",
                      labelDisplayedRows: " {from}-{to} Dari {count} Baris",
                      firstTooltip: "Halaman Pertama",
                      previousTooltip: "Halaman Sebelumnya",
                      nextTooltip: "Halaman Selanjutnya",
                      lastTooltip: "Halaman Terakhir",
                    },
                  }}
                />
              </Container>
            </div>
          </div>
        </div>
        <Footer />
      </Paper>
    </Grid>
  );
}

export default StokProduk;
